<div class="container-fluid maap-root-container">
    <app-header></app-header>
    <div class="container utilities-content mt-5">
        <div class="row vertical-center home-nav-container">

            <div class="col-md-3">
                <div>
                    <a routerLink="/variance">
                        <img src="/assets/images/button_MAAP-variance-meds.png" alt="" class="home-nav-item">
                        <span class="utility-nav-text text-dark">Variance</span>
                    </a>
                </div>
                <div class="btnSummary">
                  Identifies ADC/EHR discrepancies and patterns; provides access to validated 
                  and normalized supporting data.
                </div>
            </div>
            <div class="col-md-3" *ngIf="['DDPD','DDPC'].includes(getUserRole())">
                <div>
                  <a routerLink="/accounts">
                    <img src="/assets/images/button_MAAP-acct-managment.png" alt="" class="home-nav-item">
                    <span  class="AM_home_nav_item text-dark"><!--<span id="AMagement">-->Account <br> Management<!--</span>--></span>
                  </a>
                </div>
                <div class="acct-Summary">
                  Add, Delete, and Manage User access and authorization.
                </div>
            </div>
            <div class="col-md-3" *ngIf="['DDPD','DDPC'].includes(getUserRole())">
                <div>
                  <a routerLink="/intake-jobs">
                    <img src="/assets/images/button_MAAP-process-data.png" alt="" class="home-nav-item">
                    <span class="utility-nav-text text-dark">Process Data</span>
                  </a>
                </div>
                <div class="btnSummary">
                  Utility for Data Intake Management (ANIGENT ADMIN-STAFF Only).
                </div>
            </div>
            <div class="col-md-3">
              <div>
                  <a routerLink="/configuration">
                      <img src="/assets/images/button_MAAP-config-management.png" alt="" class="home-nav-item">
                      <span class="utility-nav-text text-dark">Configuration</span>
                  </a>
              </div>
              <div class="btnSummary">
                Utility for Notification Management, Risk Scoring Management, and 
                Additional Historical Configuration Data Intake (ANIGENT ADMIN-STAFF Only).
              </div>
          </div>
        </div>
    </div>
    <app-witness-authentication #witnessAuthDialog></app-witness-authentication>
</div>
